import { apiSlice } from "./apiSlice";

const reconApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        commonReconApi: builder.mutation({
            query: (body) => {
              let timeoutAdded = '';
              if(body?.eventType == "RECON_SHIPMENT_GET"){
                timeoutAdded='?timeout=45000'
              }
              return({
              url: `/events${timeoutAdded}`,
              method: 'POST',
              body
            })}
          }),
        fileUploadApi: builder.mutation({
          query: (body) => ({
            url: '/uploadFile',
            method: 'POST',
            body
          })
        })
    }),
    overrideExisting: false,
  })
  
  export const { useCommonReconApiMutation, useFileUploadApiMutation } = reconApi